import { createContext, useContext, type FC, type ReactNode } from "react";
import type { TeammateAgentConfigController } from "../useTeammateAgentConfigController.js";

const StaticAgentConfigContext =
  createContext<TeammateAgentConfigController | null>(null);

export interface StaticAgentConfigProviderProps {
  controller: TeammateAgentConfigController;
  children: ReactNode;
}

/**
 * Provides the shared agent-config controller to the static agent's tab
 * contents (Instructions, Configuration) so they can read and edit the
 * agent config / playbook draft while the toolbar and AI Assistant that own
 * that controller stay mounted at the layout level.
 */
export const StaticAgentConfigProvider: FC<StaticAgentConfigProviderProps> = ({
  controller,
  children,
}) => (
  <StaticAgentConfigContext.Provider value={controller}>
    {children}
  </StaticAgentConfigContext.Provider>
);

export function useStaticAgentConfig(): TeammateAgentConfigController {
  const context = useContext(StaticAgentConfigContext);
  if (!context) {
    throw new Error(
      "useStaticAgentConfig must be used within a StaticAgentConfigProvider",
    );
  }
  return context;
}
